module.exports = __webpack_public_path__ + "img/logo2.8f23f055.png";